export enum TagIndex {
  Bod,
  Partner,
  Management,
  Supervisor,
  TeamLeader,
  Staff,
  Public,
  Vendor
}

export interface ITag {
  index: TagIndex;
  name: string;
  shortName: string;
  tagged: boolean;
}

export const newTags = () => "0,0,0,0,0,0,1,0";

const tagDetails: [string, string][] = [];

// ---------------------------------------------- add tag
const addDetail = (index: TagIndex, name: string, shortName: string): void => {
  tagDetails[index] = [name, shortName];
};

addDetail(TagIndex.Bod, "BOD", "BOD");
addDetail(TagIndex.Partner, "Partner / Owner", "Partner");
addDetail(TagIndex.Management, "Management", "Management");
addDetail(TagIndex.Supervisor, "Supervisor", "Supervisor");
addDetail(TagIndex.TeamLeader, "Team Leader", "Team Leader");
addDetail(TagIndex.Staff, "Staff, Team Member, and Operator", "Staff");
addDetail(TagIndex.Public, "Public", "Public");
addDetail(TagIndex.Vendor, "Vendor", "Vendor");

// ---------------------------------------------- indexes
const tagIndexes = [
  TagIndex.Bod,
  TagIndex.Partner,
  TagIndex.Management,
  TagIndex.Supervisor,
  TagIndex.TeamLeader,
  TagIndex.Staff,
  TagIndex.Public,
  TagIndex.Vendor
];

// ---------------------------------------------- helper class
class TagHelper {
  static getName = (index: TagIndex): string => tagDetails[index][0];

  static getShortName = (index: TagIndex): string => tagDetails[index][1];

  static getTagged = (varchar: string | undefined, index: TagIndex): boolean =>
    varchar
      ? parseInt(varchar.split(",")[index])
        ? true
        : false
      : parseInt(newTags().split(",")[index])
      ? true
      : false;

  static toTags = (varchar: string | undefined): ITag[] =>
    tagIndexes.map(tagIndex => ({
      index: tagIndex,
      name: TagHelper.getName(tagIndex),
      shortName: TagHelper.getShortName(tagIndex),
      tagged: TagHelper.getTagged(varchar, tagIndex)
    }));

  static isUserTagged = (postVarchar: string, userVarchar: string): boolean =>
    TagHelper.toTags(postVarchar).reduce(
      (isShown: boolean, postTag): boolean =>
        isShown ||
        (postTag.tagged && TagHelper.getTagged(userVarchar, postTag.index)),
      false
    );

  static toggleTag = (tags: string, index: TagIndex): string => {
    const toggled = tags.split(",")[index] === "1" ? "0" : "1";
    const splitted = tags.split(",");

    splitted.splice(index, 1, toggled).toString();

    return splitted.toString();
  };
}

export default TagHelper;
